export default __webpack_public_path__ + "static/media/stc.80e05a54.svg";